"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4715],{

/***/ 94715:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Zb": function() { return /* reexport */ Card_Card; },
  "HW": function() { return /* reexport */ CardAsset; },
  "q4": function() { return /* reexport */ CardSkeleton; }
});

// UNUSED EXPORTS: CardContentA, CardContentB, CardContentC, CardContentE

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var src_define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/contexts/CursorContext/Cursor.tsx
var Cursor = __webpack_require__(52746);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
;// CONCATENATED MODULE: ./src/components/Card/@editor/index.ts


var useEditorHandlers = function(name) {
    var theme = (0,useTheme/* default */.Z)();
    return (0,Cursor/* useCursorHandlers */.h)({
        name: name,
        styles: [
            {
                name: "theme_component_card_background_color",
                label: "Background color",
                type: "color",
                default: theme.palette.background.paper
            },
            {
                name: "theme_component_card_border_radius",
                label: "Border radius",
                type: "number",
                endAdornment: "px",
                default: theme.shape.borderRadius
            },
            {
                name: "theme_component_card_box_shadow",
                label: "Box shadow",
                type: "text",
                default: theme.shadows[3]
            },
            {
                type: "divider"
            },
            {
                type: "header",
                label: "Content"
            },
            {
                name: "theme_component_card_content_border",
                label: "Border",
                placeholder: "1px solid #fff",
                type: "text",
                default: "none"
            },
            {
                name: "theme_component_card_content_button_color",
                label: "Button label color",
                type: "color",
                default: theme.palette.text.primary
            },
            {
                name: "theme_component_card_content_button_background",
                label: "Button background",
                type: "color",
                default: theme.palette.common.white
            },
            {
                name: "theme_component_card_content_button_hover_background_color",
                label: "Button hover background color",
                type: "color",
                default: theme.palette.action.hover
            },
            {
                name: "theme_component_card_content_button_active_background_color",
                label: "Button active background color",
                type: "color",
                default: theme.palette.action.active
            }, 
        ],
        configuration: [
            {
                name: "component_card_width",
                label: "Width",
                type: "number",
                endAdornment: "px",
                default: 512,
                helperText: "Specify the width of your card. The card remains responsive, but based on the width and height; an aspect ratio will be set."
            },
            {
                name: "component_card_height",
                label: "Height",
                type: "number",
                default: 288,
                endAdornment: "px"
            },
            {
                name: "component_game_carousel_card_type",
                label: "Card Type",
                type: "select",
                default: "simple",
                options: [
                    "default",
                    "simple",
                    "extensive",
                    "partial",
                    "big"
                ]
            }, 
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./node_modules/@mui/material/Card/Card.js + 1 modules
var Card = __webpack_require__(66242);
// EXTERNAL MODULE: ./node_modules/@mui/material/CardActionArea/CardActionArea.js + 1 modules
var CardActionArea = __webpack_require__(9974);
// EXTERNAL MODULE: ./src/components/Link/index.tsx
var Link = __webpack_require__(7500);
// EXTERNAL MODULE: ./src/components/ImageLoaderWrapper/index.ts + 1 modules
var ImageLoaderWrapper = __webpack_require__(62430);
// EXTERNAL MODULE: ./node_modules/@mui/material/CardMedia/CardMedia.js + 1 modules
var CardMedia = __webpack_require__(83965);
;// CONCATENATED MODULE: ./src/components/Card/CardAsset.tsx








var CardMediaStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(function(_param) /*#__PURE__*/ {
    var innerFlexSize = _param.innerFlexSize, other = (0,_object_without_properties/* default */.Z)(_param, [
        "innerFlexSize"
    ]);
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardMedia/* default */.Z, (0,src_object_spread/* default */.Z)({}, other));
}, {
    target: "efn99i20"
})(function(param) {
    var theme = param.theme, _innerFlexSize = param.innerFlexSize, innerFlexSize = _innerFlexSize === void 0 ? "auto" : _innerFlexSize;
    return (0,src_define_property/* default */.Z)({
        width: "100%",
        height: "auto",
        backgroundColor: theme.palette.grey["900"],
        pointerEvents: "none",
        marginBottom: "auto",
        "& span:first-of-type": {
            display: "block !important"
        },
        flex: innerFlexSize
    }, theme.breakpoints.down("md"), {
        flex: "auto"
    });
});
var CardAsset = function(props) {
    var width = props.width, height = props.height, className = props.className, innerFlexSize = props.innerFlexSize, other = (0,_object_without_properties/* default */.Z)(props, [
        "width",
        "height",
        "className",
        "innerFlexSize"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardMediaStyled, {
        className: className,
        innerFlexSize: innerFlexSize,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            style: {
                display: "block",
                position: "relative"
            },
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageLoaderWrapper/* ImageLoaderWrapper */.T, (0,src_object_spread/* default */.Z)({
                width: width,
                height: height
            }, other))
        })
    });
};

// EXTERNAL MODULE: ./src/contexts/HighlightContext/Highlight.tsx
var Highlight = __webpack_require__(78958);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/CardContent/CardContent.js + 1 modules
var CardContent_CardContent = __webpack_require__(44267);
;// CONCATENATED MODULE: ./src/components/Card/CardContentA.tsx









var CardContentStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContent_CardContent/* default */.Z, {
    target: "e1e8ztf40"
})(function(param) {
    var theme = param.theme;
    return {
        display: "flex",
        alignItems: "center",
        width: "100%",
        height: "100%",
        paddingTop: theme.spacing(1),
        paddingRight: theme.spacing(2),
        paddingBottom: theme.spacing(1),
        paddingLeft: theme.spacing(2),
        "&:last-child": {
            paddingBottom: theme.spacing(1)
        }
    };
});
var getText = function(val, limit) {
    if (val !== "" && val !== null && val !== undefined && (val === null || val === void 0 ? void 0 : val.length) > limit) {
        return "".concat(val.slice(0, limit - 3), "...");
    }
    return val;
};
var CardContentA_Typography = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Typography/* default */.Z, (0,src_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
// Todo: HUZ2ERA-1101 - Allow Typography props to be drilled. Had trouble extending our CardContentAProps...
var CardContentA = function(props) {
    var title = props.title, limit = props.limit, className = props.className, other = (0,_object_without_properties/* default */.Z)(props, [
        "title",
        "limit",
        "className"
    ]);
    var captionRef = react.useRef(null);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: title && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentStyled, {
            className: className,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentA_Typography, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                ref: captionRef,
                sx: {
                    width: "100%",
                    display: "inline-block"
                },
                variant: "caption",
                component: "span",
                noWrap: true
            }, other), {
                children: getText(title, limit || 35)
            }))
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Card/CardContentB.tsx









var CardContentB_CardContentStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContent_CardContent/* default */.Z, {
    target: "e1k8u2y20"
})(function(param) {
    var theme = param.theme;
    return {
        position: "relative",
        zIndex: 2,
        display: "flex",
        flexDirection: "column-reverse",
        justifyContent: "flex-end",
        alignItems: "center",
        height: "100%",
        borderTop: "none",
        pointerEvents: "none",
        paddingRight: theme.spacing(2),
        paddingLeft: theme.spacing(2),
        "&:last-child": {
            paddingBottom: theme.spacing(2)
        }
    };
});
var CardContentB_getText = function(val, limit) {
    if (val !== "" && val !== null && val !== undefined && (val === null || val === void 0 ? void 0 : val.length) > limit) {
        return "".concat(val.slice(0, limit - 3), "...");
    }
    return val;
};
var CardContentB_Typography = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Typography/* default */.Z, (0,src_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
// Todo: HUZ2ERA-1101 - Allow Typography props to be drilled. Had trouble extending our CardContentBProps...
var CardContentB = function(props) {
    var title = props.title, limit = props.limit, className = props.className, other = (0,_object_without_properties/* default */.Z)(props, [
        "title",
        "limit",
        "className"
    ]);
    var captionRef = react.useRef(null);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: title && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentB_CardContentStyled, {
            className: className,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentB_Typography, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                ref: captionRef,
                sx: {
                    width: "100%",
                    display: "inline-block"
                },
                variant: "caption",
                color: "textPrimary",
                component: "p",
                noWrap: true
            }, other), {
                children: CardContentB_getText(title, limit || 35)
            }))
        })
    });
};

// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 3 modules
var useTranslation = __webpack_require__(21122);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(83321);
;// CONCATENATED MODULE: ./src/components/Card/CardContentC.tsx












var CardContentC_Typography = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Typography/* default */.Z, (0,src_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
var CardContentC_Button = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Button/* default */.Z, (0,src_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
var CardContentC_CardContentStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContent_CardContent/* default */.Z, {
    target: "eclqiin0"
})(function(param) {
    var theme = param.theme;
    return (0,src_define_property/* default */.Z)({
        display: "none"
    }, theme.breakpoints.up("sm"), {
        position: "relative",
        zIndex: 2,
        display: "flex",
        flexDirection: "column-reverse",
        justifyContent: "flex-end",
        alignItems: "center",
        height: "100%",
        textAlign: "center",
        border: theme.theme_component_card_content_border || "none",
        borderTop: "none",
        pointerEvents: "none"
    });
});
var Description = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContentC_Typography, {
    target: "eclqiin1"
})(function(param) {
    var theme = param.theme;
    return {
        marginTop: theme.spacing(2),
        height: "80px"
    };
});
var ButtonStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContentC_Button, {
    target: "eclqiin2"
})(function(param) {
    var theme = param.theme;
    return {
        display: "inline-block",
        width: "auto",
        height: "auto",
        margin: 0,
        marginTop: theme.spacing(-3.5),
        padding: theme.spacing(0.5, 2),
        borderRadius: "100px",
        border: "1px solid #ebebeb",
        color: theme.theme_component_card_content_button_color || theme.palette.primary.contrastText,
        background: theme.theme_component_card_content_button_background || theme.palette.primary.main
    };
});
var CardContentC_getText = function(val, limit) {
    if (val !== "" && val !== null && val !== undefined && (val === null || val === void 0 ? void 0 : val.length) > limit) {
        return "".concat(val.slice(0, limit - 3), "...");
    }
    return val;
};
// Todo: HUZ2ERA-1101 - Allow Typography props to be drilled (now we have them hardcoded in our jsx).
//       Had trouble extending our CardContentCProps...
var CardContentC = function(props) {
    var description = props.description, limit = props.limit, className = props.className, other = (0,_object_without_properties/* default */.Z)(props, [
        "description",
        "limit",
        "className"
    ]);
    var t = (0,useTranslation/* useTranslation */.$)("card_content_c").t;
    var body2Ref = react.useRef(null);
    var buttonRef = react.useRef(null);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardContentC_CardContentStyled, {
        className: className,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Description, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                ref: body2Ref,
                variant: "body2",
                component: "p",
                color: "textPrimary"
            }, other), {
                children: description && CardContentC_getText(description, limit || 85)
            })),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonStyled, {
                ref: buttonRef,
                variant: "contained",
                disableElevation: true,
                disableRipple: true,
                disableFocusRipple: true,
                size: "small",
                children: t("play_now", "Play now")
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/contexts/AppContext/index.tsx + 6 modules
var AppContext = __webpack_require__(13560);
;// CONCATENATED MODULE: ./src/components/Card/CardContentE.tsx





var CardCarousel = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1kzlu9v0"
})(function() {
    return {
        position: "absolute",
        top: 0,
        left: 0,
        transition: "transform 0.2s cubic-bezier(0.5, 0, 0.1, 1)",
        cursor: "pointer"
    };
});
var CarouselCardContent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1kzlu9v1"
})(function(param) {
    var theme = param.theme;
    return {
        padding: theme.spacing(0.5),
        height: "100%"
    };
});
var CarouselCardCover = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("img", {
    target: "e1kzlu9v2"
})(function(param) {
    var theme = param.theme;
    return {
        backgroundColor: theme.palette.grey["900"],
        width: "100%",
        height: "100%",
        borderRadius: theme.spacing(1),
        boxSizing: "border-box",
        border: "1px solid transparent",
        " -webkit-box-shadow": "0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12),\n    0 1px 3px 0 rgba(0, 0, 0, 0.2)",
        boxShadow: "0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 3px 0 rgba(0, 0, 0, 0.2);",
        "-moz-box-shadow": "0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 3px 0 rgba(0, 0, 0, 0.2)"
    };
});
var CardContentE = function(props) {
    var game = props.game, width = props.width, height = props.height, pointX = props.pointX, pointY = props.pointY;
    var appContext = (0,AppContext/* useAppContext */.bp)();
    var assetUrl = appContext.useConfig().assetUrl;
    var scaleTimeout;
    var onMouseEnter = function(e) {
        var _target = e.target;
        while(_target.classList[0] !== "card-carousel"){
            // @ts-ignore
            _target = _target.parentNode;
        }
        var _cover = _target.querySelector(".carousel-card-cover");
        // @ts-ignore
        _cover.style.border = "2px solid aqua";
        if (_target.style.width !== "364px") {
            scaleTimeout = setTimeout(function() {
                // @ts-ignore
                _target.style.zIndex = 1;
                _target.style.transform = _target.style.transform + " scale(1.2)";
            }, 400);
        }
    };
    var onMouseLeave = function(e) {
        clearTimeout(scaleTimeout);
        var _target = e.target;
        while(_target.classList[0] !== "card-carousel"){
            // @ts-ignore
            _target = _target.parentNode;
        }
        _target.style.transform = _target.style.transform.replace(" scale(1.2)", "");
        // @ts-ignore
        _target.style.zIndex = null;
        var _cover = _target.querySelector(".carousel-card-cover");
        // @ts-ignore
        _cover.style.border = null;
        // @ts-ignore
        _cover.style.borderRadius = null;
    };
    if (!game) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {});
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardCarousel, {
        className: "card-carousel",
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        style: {
            width: "".concat(width, "px"),
            height: "".concat(height, "px"),
            transform: "translateX(".concat(pointX, "px) translateY(").concat(pointY, "px)")
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CarouselCardContent, {
            className: "carousel-card-content",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                href: {
                    pathname: "/game/[slug]",
                    query: {
                        slug: game.slug
                    }
                },
                title: (game === null || game === void 0 ? void 0 : game.name) || undefined,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CarouselCardCover, {
                    className: "carousel-card-cover",
                    src: "".concat(assetUrl).concat(game.images.cover16x9 || game.images.cover, "/")
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Card/CardContentF.tsx












var CardContentF_Typography = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Typography/* default */.Z, (0,src_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
var CardContentF_Button = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function(props, ref) {
    return useHighlightHandlers(MuiButton, _object_spread({
        forwardedRef: ref
    }, props));
})));
var CardContentF_CardContentStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContent_CardContent/* default */.Z, {
    target: "e1vppp510"
})(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        // paddingBottom: `${theme.spacing(3)} !important`,
        width: "100%",
        justifyContent: "space-between"
    }, (0,src_define_property/* default */.Z)(_obj, theme.breakpoints.up("sm"), {
        position: "relative",
        zIndex: 2,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        textAlign: "left",
        padding: theme.spacing(3, 4),
        height: "100%",
        border: theme.theme_component_card_content_border || "none",
        borderTop: "none",
        pointerEvents: "none"
    }), (0,src_define_property/* default */.Z)(_obj, theme.breakpoints.down("sm"), {
        display: "flex",
        flexDirection: "column",
        height: "100%"
    }), _obj;
});
var CardTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContentF_Typography, {
    target: "e1vppp511"
})(function(param) {
    var theme = param.theme;
    return (0,src_define_property/* default */.Z)({
        width: "100%",
        display: "inline-block",
        paddingBottom: theme.spacing(1),
        fontSize: theme.spacing(2.5),
        fontWeight: "bold",
        color: theme.theme_component_navigation_bar_background_color,
        whiteSpace: "inherit"
    }, theme.breakpoints.down("sm"), {
        fontSize: theme.spacing(2.25),
        lineHeight: theme.spacing(2.75)
    });
});
var CardContentF_Description = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContentF_Typography, {
    target: "e1vppp512"
})(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        height: "auto",
        fontSize: theme.spacing(2),
        color: "#6E6E6E",
        lineHeight: "28px"
    }, (0,src_define_property/* default */.Z)(_obj, theme.breakpoints.down("sm"), {
        minHeight: "80px",
        fontSize: theme.spacing(1.75),
        lineHeight: theme.spacing(2.5)
    }), (0,src_define_property/* default */.Z)(_obj, theme.breakpoints.up("lg"), {
        height: "80px"
    }), (0,src_define_property/* default */.Z)(_obj, theme.breakpoints.up("md"), (0,src_define_property/* default */.Z)({}, theme.breakpoints.down("lg"), {
        height: "70px",
        lineHeight: "20px"
    })), _obj;
});
var CardContentF_ButtonStyled = /*#__PURE__*/ (/* unused pure expression or super */ null && (styled(CardContentF_Button, {
    target: "e1vppp513"
})(function(param) {
    var theme = param.theme;
    return {
        display: "inline-block",
        width: "104px",
        height: "40px",
        margin: 0,
        marginTop: theme.spacing(3),
        padding: theme.spacing(0),
        borderRadius: "8px",
        border: "1px solid #ebebeb",
        fontSize: "16px",
        fontWeight: "bold",
        color: theme.theme_component_card_content_button_color || theme.palette.primary.contrastText,
        background: theme.theme_component_card_content_button_background || theme.palette.primary.main,
        textTransform: "none"
    };
})));
var CardContentF_getText = function(val, limit) {
    if (val !== "" && val !== null && val !== undefined && (val === null || val === void 0 ? void 0 : val.length) > limit) {
        return "".concat(val.slice(0, limit - 3), "...");
    }
    return val;
};
// Todo: HUZ2ERA-1101 - Allow Typography props to be drilled (now we have them hardcoded in our jsx).
//       Had trouble extending our CardContentCProps...
var CardContentF = function(props) {
    var description = props.description, title = props.title, limit = props.limit, className = props.className, other = (0,_object_without_properties/* default */.Z)(props, [
        "description",
        "title",
        "limit",
        "className"
    ]);
    var t = (0,useTranslation/* useTranslation */.$)("card_content_f").t;
    var body2Ref = react.useRef(null);
    var buttonRef = react.useRef(null);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardContentF_CardContentStyled, {
        className: className,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardTitle, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                variant: "caption",
                component: "span",
                noWrap: true
            }, other), {
                children: CardContentF_getText(title || "", limit || 35)
            })),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentF_Description, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                ref: body2Ref,
                variant: "body2",
                component: "p",
                color: "textPrimary"
            }, other), {
                children: description && CardContentF_getText(description, limit || 85)
            }))
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
;// CONCATENATED MODULE: ./src/components/Card/CardContentBanner.tsx





function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 16px;\n    text-transform: none;\n    white-space: normal;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 7;\n    display: -webkit-box;\n    color: #6E6E6E;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var CardContentBanner_Button = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Button/* default */.Z, (0,src_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
var CardContentBanner_CardContentStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContent_CardContent/* default */.Z, {
    target: "e9ri2380"
})(function(param) {
    var theme = param.theme;
    return {
        display: "flex",
        alignItems: "flex-start",
        textAlign: "left",
        width: "100%",
        height: "100%",
        paddingTop: theme.spacing(1),
        paddingRight: theme.spacing(0),
        paddingBottom: theme.spacing(1),
        paddingLeft: theme.spacing(0),
        "&:last-child": {
            paddingBottom: theme.spacing(1)
        }
    };
});
var CardWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContentBanner_Button, {
    target: "e9ri2381"
})(function(param) {
    var theme = param.theme;
    return (0,src_define_property/* default */.Z)({
        padding: theme.spacing(0, 5),
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        width: "30%"
    }, theme.breakpoints.down("md"), {
        alignItems: "normal",
        width: "auto"
    });
});
var CardContentBanner_ButtonStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContentBanner_Button, {
    target: "e9ri2382"
})(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        display: "inline-block",
        width: "104px",
        height: "40px",
        margin: 0,
        padding: theme.spacing(0),
        borderRadius: "8px",
        border: "1px solid #B1B1B1",
        marginLeft: theme.spacing(0),
        marginTop: theme.spacing(1),
        fontSize: "16px",
        fontWeight: "bold",
        color: theme.theme_component_card_content_button_color || theme.palette.primary.contrastText,
        background: theme.theme_component_card_content_button_background || theme.palette.primary.main,
        textTransform: "none"
    }, (0,src_define_property/* default */.Z)(_obj, theme.breakpoints.down("md"), {
        marginBottom: theme.spacing(3)
    }), (0,src_define_property/* default */.Z)(_obj, "&:hover", {
        backgroundColor: "#cc0100"
    }), _obj;
});
var CardContentBanner_getText = function(val, limit) {
    if (val !== "" && val !== null && val !== undefined && (val === null || val === void 0 ? void 0 : val.length) > limit) {
        return "".concat(val.slice(0, limit - 3), "...");
    }
    return val;
};
var CardContentBanner_Typography = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Typography/* default */.Z, (0,src_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
var DescriptionStyled = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)((0,emotion_styled_browser_esm/* default */.Z)(Typography/* default */.Z)(_templateObject()), (0,src_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
var CardContentBanner = function(props) {
    var title = props.title, description = props.description, limit = props.limit, className = props.className, other = (0,_object_without_properties/* default */.Z)(props, [
        "title",
        "description",
        "limit",
        "className"
    ]);
    var captionRef = react.useRef(null);
    var buttonRef = react.useRef(null);
    var t = (0,useTranslation/* useTranslation */.$)("card_content_banner").t;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: title && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardWrapper, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentBanner_CardContentStyled, {
                    className: className,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentBanner_Typography, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                        ref: captionRef,
                        sx: {
                            width: "100%",
                            display: "inline-block",
                            fontWeight: 700,
                            fontSize: "20px",
                            color: "#0C0C0C"
                        },
                        variant: "caption",
                        component: "span",
                        noWrap: true
                    }, other), {
                        children: CardContentBanner_getText(title, limit || 35)
                    }))
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentBanner_CardContentStyled, {
                    className: className,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DescriptionStyled, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                        ref: captionRef,
                        variant: "caption",
                        color: "textPrimary",
                        component: "span",
                        noWrap: true
                    }, other), {
                        children: description
                    }))
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentBanner_ButtonStyled, {
                    ref: buttonRef,
                    variant: "contained",
                    disableElevation: true,
                    disableRipple: true,
                    disableFocusRipple: true,
                    size: "small",
                    children: t("play_now", "Play")
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Card/CollectionContentA.tsx










var CollectionContentA_Typography = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Typography/* default */.Z, (0,src_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
var CollectionContentA_CardContentStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContent_CardContent/* default */.Z, {
    target: "e1rr55dw0"
})(function(param) {
    var theme = param.theme;
    return (0,src_define_property/* default */.Z)({
        width: "100%",
        paddingBottom: "".concat(theme.spacing(1.5), " !important")
    }, theme.breakpoints.up("sm"), {
        position: "relative",
        zIndex: 2,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        textAlign: "left",
        padding: theme.spacing(1, 1.5),
        height: "100%",
        border: theme.theme_component_card_content_border || "none",
        borderTop: "none",
        pointerEvents: "none"
    });
});
var CollectionContentA_CardTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CollectionContentA_Typography, {
    target: "e1rr55dw1"
})(function(param) {
    var theme = param.theme;
    return {
        width: "100%",
        display: "inline-block",
        fontSize: theme.spacing(2.25),
        fontWeight: "bold",
        color: "#000"
    };
});
var CollectionContentA_Description = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CollectionContentA_Typography, {
    target: "e1rr55dw2"
})(function(param) {
    var theme = param.theme;
    return {
        height: "auto",
        fontSize: theme.spacing(2)
    };
});
var CollectionContentA_getText = function(val, limit) {
    if (val !== "" && val !== null && val !== undefined && (val === null || val === void 0 ? void 0 : val.length) > limit) {
        return "".concat(val.slice(0, limit - 3), "...");
    }
    return val;
};
// Todo: HUZ2ERA-1101 - Allow Typography props to be drilled (now we have them hardcoded in our jsx).
//       Had trouble extending our CardContentCProps...
var CollectionContentA = function(props) {
    var description = props.description, title = props.title, limit = props.limit, className = props.className, other = (0,_object_without_properties/* default */.Z)(props, [
        "description",
        "title",
        "limit",
        "className"
    ]);
    var body2Ref = react.useRef(null);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CollectionContentA_CardContentStyled, {
        className: className,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionContentA_CardTitle, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                variant: "caption",
                component: "span",
                noWrap: true
            }, other), {
                children: CollectionContentA_getText(title || "", limit || 35)
            })),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionContentA_Description, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                ref: body2Ref,
                variant: "body2",
                component: "p",
                color: "textPrimary"
            }, other), {
                children: description && CollectionContentA_getText(description, limit || 75)
            }))
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Card/CollectionContentC.tsx











var CollectionContentC_Typography = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Typography/* default */.Z, (0,src_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
var CollectionContentC_CardContentStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContent_CardContent/* default */.Z, {
    target: "erfbzur0"
})(function(param) {
    var theme = param.theme;
    return (0,src_define_property/* default */.Z)({
        width: "100%",
        flex: 1
    }, theme.breakpoints.up("sm"), {
        position: "relative",
        zIndex: 2,
        display: "flex",
        alignItems: "baseline",
        justifyContent: "space-between",
        textAlign: "left",
        padding: theme.spacing(2),
        height: "100%",
        border: theme.theme_component_card_content_border || "none",
        borderTop: "none",
        pointerEvents: "none"
    });
});
var CardContentInfo = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "erfbzur1"
})(function(param) {
    var theme = param.theme;
    return {};
});
var CollectionContentC_CardTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CollectionContentC_Typography, {
    target: "erfbzur2"
})(function(param) {
    var theme = param.theme;
    return {
        width: "100%",
        display: "inline-block",
        fontSize: theme.spacing(3),
        fontWeight: "bold",
        color: "#000"
    };
});
var CollectionContentC_Description = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CollectionContentC_Typography, {
    target: "erfbzur3"
})(function(param) {
    var theme = param.theme;
    return {
        height: "auto",
        fontSize: theme.spacing(2)
    };
});
var CollectionContentC_ButtonStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Button/* default */.Z, {
    target: "erfbzur4"
})(function(param) {
    var theme = param.theme;
    return {
        display: "inline-block",
        width: "auto",
        height: "auto",
        margin: 0,
        marginTop: theme.spacing(-3.5),
        padding: theme.spacing(0.5, 2),
        borderRadius: "100px",
        border: "1px solid #ebebeb",
        color: theme.theme_component_card_content_button_color || theme.palette.primary.contrastText,
        background: theme.theme_component_card_content_button_background || theme.palette.primary.main
    };
});
var CollectionContentC_getText = function(val, limit) {
    if (val !== "" && val !== null && val !== undefined && (val === null || val === void 0 ? void 0 : val.length) > limit) {
        return "".concat(val.slice(0, limit - 3), "...");
    }
    return val;
};
var CollectionContentC = function(props) {
    var description = props.description, title = props.title, limit = props.limit, className = props.className, other = (0,_object_without_properties/* default */.Z)(props, [
        "description",
        "title",
        "limit",
        "className"
    ]);
    var t = (0,useTranslation/* useTranslation */.$)("card_content_c").t;
    var body2Ref = react.useRef(null);
    var buttonRef = react.useRef(null);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: title && description && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CollectionContentC_CardContentStyled, {
            className: className,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardContentInfo, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionContentC_CardTitle, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                            variant: "caption",
                            component: "span",
                            noWrap: true
                        }, other), {
                            children: CollectionContentC_getText(title || "", limit || 35)
                        })),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionContentC_Description, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                            ref: body2Ref,
                            variant: "body2",
                            component: "p",
                            color: "textPrimary"
                        }, other), {
                            children: description && CollectionContentC_getText(description, limit || 80)
                        }))
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionContentC_ButtonStyled, {
                    ref: buttonRef,
                    variant: "contained",
                    disableElevation: true,
                    disableRipple: true,
                    disableFocusRipple: true,
                    size: "small",
                    children: t("play_now", "Play now")
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Card/CardContentFHardcoded.tsx













var CardContentFHardcoded_Typography = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Typography/* default */.Z, (0,src_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
var CardContentFHardcoded_Button = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function(props, ref) {
    return useHighlightHandlers(MuiButton, _object_spread({
        forwardedRef: ref
    }, props));
})));
var CardContentFHardcoded_CardContentStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContent_CardContent/* default */.Z, {
    target: "ex580fn0"
})(function(param) {
    var theme = param.theme;
    return (0,src_define_property/* default */.Z)({
        // paddingBottom: `${theme.spacing(3)} !important`,
        width: "100%",
        justifyContent: "space-between"
    }, theme.breakpoints.up("sm"), {
        position: "relative",
        zIndex: 2,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        textAlign: "left",
        padding: theme.spacing(3, 2),
        height: "100%",
        border: theme.theme_component_card_content_border || "none",
        borderTop: "none",
        pointerEvents: "none"
    });
});
var CardContentFHardcoded_CardTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContentFHardcoded_Typography, {
    target: "ex580fn1"
})(function(param) {
    var theme = param.theme;
    return (0,src_define_property/* default */.Z)({
        width: "100%",
        display: "inline-block",
        paddingBottom: theme.spacing(1),
        fontWeight: "bold",
        color: theme.theme_component_navigation_bar_background_color,
        whiteSpace: "inherit",
        fontSize: "20px",
        lineHeight: "26px"
    }, theme.breakpoints.down("sm"), {
        fontSize: "18px",
        lineHeight: "22px"
    });
});
var CardContentFHardcoded_Description = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CardContentFHardcoded_Typography, {
    target: "ex580fn2"
})(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        height: "50px",
        marginBottom: theme.spacing(3),
        fontSize: theme.spacing(2),
        color: "#6E6E6E",
        lineHeight: "28px"
    }, (0,src_define_property/* default */.Z)(_obj, theme.breakpoints.up("md"), (0,src_define_property/* default */.Z)({}, theme.breakpoints.down("lg"), {
        lineHeight: "20px"
    })), (0,src_define_property/* default */.Z)(_obj, theme.breakpoints.down("sm"), {
        lineHeight: "20px",
        height: "60px",
        fontSize: "14px"
    }), _obj;
});
var LinkContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Link/* Link */.r, {
    target: "ex580fn3"
})(function(param) {
    var theme = param.theme;
    return (0,src_define_property/* default */.Z)({
        color: theme.theme_component_navigation_bar_background_color || "#0C0C0C",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "18px",
        fontWeight: 500,
        textAlign: "center",
        textDecoration: "none"
    }, theme.breakpoints.down("sm"), {
        fontSize: "14px",
        lineHeight: "18px",
        textAlign: "left",
        justifyContent: "flex-start"
    });
});
var CardContentFHardcoded_getText = function(val, limit) {
    if (val !== "" && val !== null && val !== undefined && (val === null || val === void 0 ? void 0 : val.length) > limit) {
        return "".concat(val.slice(0, limit - 3), "...");
    }
    return val;
};
// Todo: HUZ2ERA-1101 - Allow Typography props to be drilled (now we have them hardcoded in our jsx).
//       Had trouble extending our CardContentCProps...
var CardContentFHardcoded = function(props) {
    var description = props.description, title = props.title, limit = props.limit, className = props.className, other = (0,_object_without_properties/* default */.Z)(props, [
        "description",
        "title",
        "limit",
        "className"
    ]);
    var t = (0,useTranslation/* useTranslation */.$)("card_content_f").t;
    var body2Ref = react.useRef(null);
    var buttonRef = react.useRef(null);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardContentFHardcoded_CardContentStyled, {
        className: className,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentFHardcoded_CardTitle, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                variant: "caption",
                component: "span",
                noWrap: true
            }, other), {
                children: CardContentFHardcoded_getText(title || "", limit || 35)
            })),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentFHardcoded_Description, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                ref: body2Ref,
                variant: "body2",
                component: "p",
                color: "textPrimary"
            }, other), {
                children: description && CardContentFHardcoded_getText(description, limit || 130)
            })),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LinkContainer, {
                href: "https://cnn.it/5thingsquiz",
                children: [
                    "Test your knowledge ",
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
                        width: "21",
                        height: "21",
                        viewBox: "0 0 21 21",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M7.41076 4.20297C7.7362 3.87753 8.26384 3.87753 8.58928 4.20297L14.4226 10.0363C14.748 10.3617 14.748 10.8894 14.4226 11.2148L8.58928 17.0481C8.26384 17.3736 7.7362 17.3736 7.41076 17.0481C7.08533 16.7227 7.08533 16.1951 7.41076 15.8696L12.6548 10.6256L7.41076 5.38148C7.08533 5.05604 7.08533 4.52841 7.41076 4.20297Z",
                            fill: "#0C0C0C"
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@mui/material/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(98396);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-element-cbed451f.browser.esm.js
var emotion_element_cbed451f_browser_esm = __webpack_require__(54880);
;// CONCATENATED MODULE: ./src/components/Card/CollectionContentB.tsx










var CollectionContentB_Typography = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function(props, ref) {
    return useHighlightHandlers(MuiTypography, _object_spread({
        forwardedRef: ref
    }, props));
})));
var CollectionContentB_CardContentStyled = /*#__PURE__*/ (/* unused pure expression or super */ null && (styled(CardContent, {
    target: "eent4cw0"
})(function(param) {
    var theme = param.theme;
    return _define_property({
        paddingBottom: "".concat(theme.spacing(2), " !important"),
        width: "100%"
    }, theme.breakpoints.up("sm"), {
        position: "relative",
        zIndex: 2,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        textAlign: "left",
        padding: theme.spacing(3, 2),
        height: "100%",
        border: theme.theme_component_card_content_border || "none",
        borderTop: "none",
        pointerEvents: "none"
    });
})));
var CollectionContentB_CardTitle = /*#__PURE__*/ (/* unused pure expression or super */ null && (styled(CollectionContentB_Typography, {
    target: "eent4cw1"
})(function(param) {
    var theme = param.theme;
    return {
        width: "100%",
        display: "inline-block",
        paddingBottom: theme.spacing(1),
        fontSize: theme.spacing(4.375),
        fontWeight: "bold",
        color: "#000"
    };
})));
var CollectionContentB_Description = /*#__PURE__*/ (/* unused pure expression or super */ null && (styled(CollectionContentB_Typography, {
    target: "eent4cw2"
})(function(param) {
    var theme = param.theme;
    return {
        height: "auto",
        fontSize: theme.spacing(2.5)
    };
})));
var CollectionContentB_getText = function(val, limit) {
    if (val !== "" && val !== null && val !== undefined && (val === null || val === void 0 ? void 0 : val.length) > limit) {
        return "".concat(val.slice(0, limit - 3), "...");
    }
    return val;
};
// Todo: HUZ2ERA-1101 - Allow Typography props to be drilled (now we have them hardcoded in our jsx).
//       Had trouble extending our CardContentCProps...
var CollectionContentB = function(props) {
    var description = props.description, title = props.title, limit = props.limit, className = props.className, other = (0,_object_without_properties/* default */.Z)(props, [
        "description",
        "title",
        "limit",
        "className"
    ]);
    var body2Ref = react.useRef(null);
    var theme = (0,emotion_element_cbed451f_browser_esm.a)();
    var md = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("sm"));
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {});
};

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/components/Card/Card.tsx
























var CardStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Card/* default */.Z, {
    target: "ejnpo760"
})(function(param) {
    var theme = param.theme, template = param.template, hoverEffect = param.hoverEffect, cardBorder = param.cardBorder;
    return {
        width: "100%",
        // height: '100%',
        backgroundColor: theme.theme_component_card_background_color || theme.palette.background.paper,
        boxShadow: theme.theme_component_card_box_shadow || theme.shadows[3],
        borderRadius: template === "big" ? 0 : "".concat(theme.theme_component_card_border_radius, "px") || 0,
        border: cardBorder || "".concat(theme.theme_component_card_content_border, "px") || 0,
        borderStyle: theme.theme_component_card_content_border ? "solid" : "none",
        borderColor: theme.theme_component_card_content_border ? theme.theme_component_card_content_border_color : "none",
        transition: "transform ".concat(theme.transitions.duration.shortest, "ms ").concat(theme.transitions.easing.easeInOut),
        "&:hover": hoverEffect && {
            transform: "scale3d(1.05, 1.05, 1)"
        }
    };
});
var Inner = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ejnpo761"
})(function(param) {
    var theme = param.theme, _innerFlex = param.innerFlex, innerFlex = _innerFlex === void 0 ? "column" : _innerFlex, _innerAlign = param.innerAlign, innerAlign = _innerAlign === void 0 ? "normal" : _innerAlign;
    return(// height: '100%',
    (0,src_define_property/* default */.Z)({
        display: "flex",
        flexDirection: innerFlex,
        alignItems: innerAlign
    }, theme.breakpoints.down("md"), {
        flexDirection: "column"
    }));
});
var Card_Card = function(props) {
    var href = props.href, src = props.src, width = props.width, height = props.height, alt = props.alt, template = props.template, title = props.title, description = props.description, className = props.className, sx = props.sx, typographyOptions = props.typographyOptions, hoverEffect = props.hoverEffect, innerFlex = props.innerFlex, innerFlexSize = props.innerFlexSize, cardBorder = props.cardBorder, other = (0,_object_without_properties/* default */.Z)(props, [
        "href",
        "src",
        "width",
        "height",
        "alt",
        "template",
        "title",
        "description",
        "className",
        "sx",
        "typographyOptions",
        "hoverEffect",
        "innerFlex",
        "innerFlexSize",
        "cardBorder"
    ]);
    var appContext = (0,AppContext/* useAppContext */.bp)();
    var componentOptions = appContext.useConfig().componentOptions;
    var x = width || componentOptions.component_card_width || 100;
    var y = height || componentOptions.component_card_height || 100;
    var CommonCardContainer = function(param) {
        var children = param.children;
        var router = (0,next_router.useRouter)();
        var basePath = router.basePath || "";
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardStyled, (0,_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            elevation: 0,
            className: className,
            sx: sx,
            hoverEffect: hoverEffect,
            template: template,
            cardBorder: cardBorder
        }, useEditorHandlers("Card")), {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardActionArea/* default */.Z, {
                component: Link/* Link */.r,
                href: href || "/",
                sx: {
                    height: "100%"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Inner, {
                    innerFlexSize: innerFlexSize,
                    innerFlex: innerFlex,
                    style: {
                        alignItems: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardAsset, (0,src_object_spread/* default */.Z)({
                            innerFlexSize: innerFlexSize,
                            src: "".concat(basePath).concat(src),
                            width: x,
                            height: y,
                            alt: alt
                        }, other)),
                        children
                    ]
                })
            })
        }));
    };
    var cardTemplates = {
        default: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CommonCardContainer, {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentA, (0,src_object_spread/* default */.Z)({
                title: title,
                description: description
            }, typographyOptions))
        }),
        simple: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CommonCardContainer, {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentB, (0,src_object_spread/* default */.Z)({
                title: title
            }, typographyOptions))
        }),
        extensive: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CommonCardContainer, {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentC, (0,src_object_spread/* default */.Z)({
                description: description
            }, typographyOptions))
        }),
        big: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CommonCardContainer, {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {})
        }),
        cnn: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CommonCardContainer, {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentF, (0,src_object_spread/* default */.Z)({
                title: title,
                description: description
            }, typographyOptions))
        }),
        banner: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CommonCardContainer, {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentBanner, (0,src_object_spread/* default */.Z)({
                title: title,
                description: description
            }, typographyOptions))
        }),
        cnnactivities: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CommonCardContainer, {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentFHardcoded, (0,src_object_spread/* default */.Z)({
                title: title,
                description: description
            }, typographyOptions))
        }),
        partial: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContentE, (0,src_object_spread/* default */.Z)({
            width: width,
            height: height
        }, other)),
        CarouselA: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CommonCardContainer, {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionContentA, (0,src_object_spread/* default */.Z)({
                title: title,
                description: description
            }, other))
        }),
        CarouselB: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CommonCardContainer, {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionContentB, {})
        }),
        FeatureGridA: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CommonCardContainer, {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionContentC, (0,src_object_spread/* default */.Z)({
                title: title,
                description: description
            }, other))
        })
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: cardTemplates[template || "default"]
    });
};

// EXTERNAL MODULE: ./src/components/PaperColorElevation/index.ts + 1 modules
var PaperColorElevation = __webpack_require__(80830);
;// CONCATENATED MODULE: ./src/components/Card/CardSkeleton.tsx




var CardSkeletonStyled = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(PaperColorElevation/* PaperColorElevation */.z, {
    target: "e17ommov0"
})(function(param) {
    var theme = param.theme;
    return {
        width: "100%",
        height: "100%",
        borderRadius: theme.theme_component_card_border_radius || theme.shape.borderRadius,
        backgroundColor: theme.theme_component_card_background_color || theme.palette.background.paper
    };
});
var CardSkeleton = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardSkeletonStyled, (0,src_object_spread/* default */.Z)({}, props));
};

;// CONCATENATED MODULE: ./src/components/Card/index.ts









/***/ })

}]);